import React from 'react';
import Container from '../../../components/UI/Container';
import { enFr, getLang } from '../../../utils';
import { fixImagePaths } from '../../../utils/image-helpers';
import { openCalendarModal } from '../../../utils/modal-helpers.jsx';
import ConsultingServicesWrapper from './consultingServices.style';

import awakenData from '../../../assets/data/awaken/index.json';
import awakenFrenchData from '../../../assets/data/awaken-french/index.json';

const StrategyIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
  </svg>
);

const IntegrationIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 18 22 12 16 6" />
    <polyline points="8 6 2 12 8 18" />
    <line x1="10" y1="2" x2="14" y2="22" />
  </svg>
);

const AdvisoryIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const EnablementIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const DevelopmentIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
    <polyline points="8 10 5 13 8 16" />
    <polyline points="16 10 19 13 16 16" />
    <line x1="12" y1="8" x2="12" y2="18" />
    <line x1="8" y1="21" x2="16" y2="21" />
  </svg>
);

const icons = {
  development: DevelopmentIcon,
  strategy: StrategyIcon,
  integration: IntegrationIcon,
  advisory: AdvisoryIcon,
  enablement: EnablementIcon,
};

const ConsultingServices = () => {
  const lang = getLang();
  const localizedData = fixImagePaths(lang === 'fr' ? awakenFrenchData : awakenData);
  const services = localizedData.CONSULTING_SERVICES || awakenData.CONSULTING_SERVICES;

  return (
    <ConsultingServicesWrapper id="services">
      <Container>
        <div className="section-header">
          <h2>{enFr('Services', 'Services')}</h2>
          <p className="section-subtitle">
            {enFr(
              'From custom software development to AI strategy and systems integration, we deliver technical solutions that move your business forward.',
              'Du développement logiciel sur mesure à la stratégie IA et l\u2019intégration de systèmes, nous livrons des solutions techniques qui font avancer votre entreprise.'
            )}
          </p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => {
            const IconComponent = icons[service.icon] || StrategyIcon;
            return (
              <div className="service-card" key={index}>
                <div className="card-header">
                  <div className="icon-wrapper">
                    <IconComponent />
                  </div>
                  <h3>{service.title}</h3>
                </div>
                <p className="service-description">{service.description}</p>
                <div className="service-details">
                  <div className="detail-row">
                    <span className="detail-label">{enFr('For', 'Pour')}</span>
                    <span className="detail-text">{service.forWhom}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">{enFr('Outcome', 'Résultat')}</span>
                    <span className="detail-text">{service.outcome}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">{enFr('Format', 'Format')}</span>
                    <span className="detail-text">{service.format}</span>
                  </div>
                </div>
                <ul className="service-items">
                  {service.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
        <div className="services-cta">
          <button onClick={openCalendarModal} type="button">
            {enFr('Book a Strategy Call', 'Réserver un appel stratégique')}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </button>
        </div>
      </Container>
    </ConsultingServicesWrapper>
  );
};

export default ConsultingServices;
